module.exports = __webpack_public_path__ + "img/taxi.3f4ec9d1.png";